const AddActivityRequest = function (memberId) {
  this.MemberId = memberId || null;
  this.ChannelType = null;
  this.CallCategory = null;
  this.Category = null;
  this.Comments = null;
  this.Priority = null;
};
export default AddActivityRequest;
